import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  NoUserDataIconComponent,
  RemoveItemIconComponent,
} from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { Option } from '../../../models/option.model';
import { AvatarPipe } from '../../../../../ui-components/pipes/avatar/avatar.pipe';

@Component({
  selector: 'lib-assign-group-user-card',
  imports: [
    AvatarPipe,
    TranslocoPipe,
    NoUserDataIconComponent,
    RemoveItemIconComponent,
  ],
  templateUrl: './assign-group-user-card.component.html',
  styleUrl: './assign-group-user-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AssignGroupUserCardComponent {
  cards = input<Option[]>([]);
  selectCard = output<Option>();
  removeCard = output<Option>();
  section = input.required<'results' | 'select'>();
  itemType = input.required<'User' | 'Group'>();

  onSelectCard(user: Option) {
    if (this.section() === 'results' && !user.isSelected) {
      this.selectCard.emit(user);
    } else if (this.section() === 'select') {
      this.removeCard.emit(user);
    }
  }
}
